import { loremIpsum } from 'lorem-ipsum';

function getLoremIpsum(length) {
  const generatedText = loremIpsum({
    count: 20,
    format: 'plain',
    paragraphLowerBound: 3,
    paragraphUpperBound: 7,
    random: Math.random,
    sentenceLowerBound: 5,
    sentenceUpperBound: 15
  });

  return generatedText.slice(0, length);
}

export function generateData(contentFieldInfo) {
  const { field_type: fieldType, field_addition: fieldAddition } = contentFieldInfo;

  if (fieldType === 'text') {
    const generatedText = getLoremIpsum(fieldAddition.characterLimit / 2);
    return generatedText;
  }
  if (fieldType === 'tinymce') {
    const generatedRichText = getLoremIpsum(150);
    return generatedRichText;
  }
  if (fieldType === 'file') {
    const { ratioWidth, ratioHeight } = fieldAddition;
    const width = 1280;
    const height = (width * ratioHeight) / ratioWidth;
    const generatedImage = `https://picsum.photos/${width}/${height}`;

    return generatedImage;
  }

  return '';
}
